export default state => {
  return state.link_manual
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/getters/orderCustomFormLinkManual.js